import Image from "next/image";
import { type CSSProperties } from "react";

import { ASSETS_URL } from "@/config/deployConstants";
import { themeColors } from "@/utils/themeColors";
import Box from "@mui/material/Box";

type Props = {
    style?: CSSProperties;
    imageDimension: { width: number; height: number };
};

export const KaiIcon = ({
    ref,
    style = {},
    imageDimension,
}: Props & {
    ref?: React.RefObject<HTMLDivElement>;
}) => {
    return (
        <Box
            ref={ref}
            sx={{
                display: "flex",
                width: "6rem",
                height: "6rem",
                justifyContent: "center",
                alignItems: "center",
                gap: "1.36rem",
                backgroundColor: themeColors.pureBlack,
                transition: "background-color 0.5s",
                ...style,
            }}>
            <Image
                src={`${ASSETS_URL}/images/ai-summarizer-kai.svg`}
                width={imageDimension.width}
                height={imageDimension.height}
                alt="robot"
                style={{ flexShrink: 0 }}
            />
        </Box>
    );
};

KaiIcon.displayName = "KaiIcon";
